import React from 'react';
import { useSelector } from 'react-redux';
import { CardForEvents } from '@yme/molecules/cards/card-for-events';
import { getIsInAuthor, getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { AspectRatio } from '@yme/utils/constants';
import { getProductURL } from '@yme/utils/product';
export function PartnerCard({ cardData: { partnerName, partnerLogo, partnerIntro, _path }, detailsPageUrl, }) {
    const isInAuthor = useSelector(getIsInAuthor);
    const isRightToLeft = useSelector(getRTL);
    const { t } = useTranslation();
    const link = getProductURL({
        path: detailsPageUrl,
        isInAuthor,
        slug: _path.split('/').at(-1),
    });
    const image = {
        src: partnerLogo?._path ?? '',
        alt: partnerName,
    };
    return (React.createElement(CardForEvents, { isRightToLeft: isRightToLeft, cardProps: {
            title: partnerName,
            description: partnerIntro.html,
            image,
            aspectRatio: AspectRatio.RectangleLevel3,
            link,
            labelLink: t('common_readMore_link'),
            isContainFit: true,
        } }));
}
